import { Component, OnInit } from '@angular/core';
import { ManuscriptsService } from '../../../services/manuscripts.service';
import { VocsService } from '../../../services/vocs.service';
import { VocTerms } from '../../../models/voc-term';
import { MsWorkList } from '../../../models/ms-work';
import { MsImageLink } from '../../../models/ms-image-link';

@Component({
  selector: 'app-ms-details-remarkpass',
  templateUrl: './ms-details-remarkpass.component.html',
  styleUrls: ['./ms-details-remarkpass.component.css']
})
export class MsDetailsRemarkpassComponent implements OnInit {
    works: MsWorkList; // current manuscript works
    remarkPassTypesVoc: VocTerms; // vocabulary of manuscript remarkable passage types
    annotationTypesVoc: VocTerms; // vocabulary of image annotation types

    constructor(
        private manuscriptsService: ManuscriptsService,
        private vocsService: VocsService
        ) {
    }

    ngOnInit(): void {
        this.manuscriptsService.getManuscriptWorks()
            .subscribe(response => this.works = response, err => console.error(err));
        this.vocsService.getRemarkPassTypes()
            .subscribe(response => this.remarkPassTypesVoc = response, err => console.error(err));
        this.vocsService.getAnnotationTypes()
            .subscribe(response => this.annotationTypesVoc = response, err => console.error(err));
    }

    selectImage(imageLink: MsImageLink): void {
        this.manuscriptsService.selectMsImageLink(imageLink);
    }

}



// WEBPACK FOOTER //
// ./src/app/components/ui/ms-details-remarkpass/ms-details-remarkpass.component.ts